import React, { memo, PropsWithChildren } from "react";

import { OrientationBlocker } from "./orientation-blocker";

export const OrientationBlockerContainer = memo(function OrientationBlockerContainer({
	children,
}: PropsWithChildren) {
	const isMobileDeviceCookie = eXpress.platform.cookies.getCookie("IsMobileDevice");
	if (!isMobileDeviceCookie) return null;

	return <OrientationBlocker>{children}</OrientationBlocker>;
});
